import NodeHandler from '../node_handler'
import DateField from './fields/date'
import TextField from './fields/text'
import PasswordField from './fields/password'
import EmailField from './fields/email'
import CheckboxField from './fields/checkbox'
import SelectField from './fields/select'
import FileField from './fields/file'
import ImageField from './fields/image'
// import { SimpleDispatcher } from '../simple_dispatcher'

const fieldClasses = {
    date: DateField,
    password: PasswordField,
    email: EmailField,
    checkbox: CheckboxField,
    select: SelectField,
    file: FileField,
    image: ImageField,
}

function initFormField(node){
    const type = node.getAttribute('data-type')
    let classInstance = fieldClasses?.[type] || TextField
    return new classInstance(node)
}

class Form extends NodeHandler{
    __init_dom_schema(){
        return {
            submit: 'button.js-submit',
            fields: {
                selector: '.js-form-field',
                is_single: false,
            },
        }
    }
    __init(){
        this.initFields()
        this.mayBeInitAjax()
        this.validate()
    }
    initFields(){
        this.fields = {}
        for(const dom_field of this.dom.fields){
            let field = initFormField(dom_field)
            field.addEventListener('changed', this.validate.bind(this))
            this.fields[field.name] = field
        }
    }
    mayBeInitAjax(){
        if(this.node.classList.contains('-ajax')){           
            this.action_url = this.node.getAttribute('action')
            this.__init_dom('token', '[name="csrfmiddlewaretoken"]')
            this.__init_dom_actions(this.dom.submit, {
                'click': this.onAjaxSubmit.bind(this)
            })

            this.modal_name = this.node.getAttribute('data-modal')
        }
    }
    getCSRFToken(){
        return this.dom.token.value
    }
    onAjaxSubmit(event){
        event.stopPropagation()
        event.preventDefault()
        const form_data = new FormData(this.node)
        // form_data.delete('csrfmiddlewaretoken')
        fetch(this.action_url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
            },
            body: form_data
        })
            .then(res => {
                console.log(res)
                if(res.status == 422){
                    return  res.json().then(data => {
                        for(const [name, message] of Object.entries(data)){
                            console.log(name, message, this.fields)
                            this.fields[name].setErrors(message)
                        }
                    })
                }else if(res.status == 200){
                    window.location.reload()
                    // return res.json().then(data => {
                    //     console.log(data)
                    //     // if(this.modal_name){
                    //         // SimpleDispatcher.dispatch(`${this.modal_name}_close`)
                    //         // SimpleDispatcher.dispatch(`success_modal_open`)
                    //     // }
                    //     // window.location.reload()
                    // })
                }
            })
            .catch(error => console.log(error))
    }
    validate(){
        let is_valid = true
        // console.log(this.fields)
        for(const field of Object.values(this.fields)){
            if(field.isRequired() && !field.isFilled()){
                is_valid = false
                break
            }
        }
        this.dom.submit.toggleAttribute('disabled', !is_valid)
    }
}

export default Form

export {
    initFormField,
}